import React from 'react';
import { User } from '@core/generated/gql-types';
import {
  OnboardingProgress,
  LatestNote,
  CandidateDetails,
  ClassificationLevelsPanel,
  CandidateSummary,
  PersonalInformation,
  VevoWorkEntitlement,
} from './components';
import { isFeatureEnabled } from '@/utils/featureFlags';

interface DetailsProps {
  worker: User;
  onViewNotes: () => void;
}

const Details: React.FC<DetailsProps> = ({ worker, onViewNotes }) => {
  return (
    <div className="space-y-6">
      <OnboardingProgress worker={worker} />
      <LatestNote worker={worker} onViewNotes={onViewNotes} />
      <CandidateDetails worker={worker} />
      <ClassificationLevelsPanel worker={worker} />
      {isFeatureEnabled('candidateSummary') && (
        <CandidateSummary worker={worker} />
      )}
      <PersonalInformation worker={worker} />
      <VevoWorkEntitlement worker={worker} />
    </div>
  );
};

export default Details;
